<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CX8KE6/tc-custom/9781466850996.jpg?1732047498509" alt="This image is the cover for the book Last Thousand"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Thousand
      </h1>
      <p class="bookDescription body article font2">
        <p>Under the protection of foreign forces, a special place has flourished in Afghanistan. The Marefat School is an award-winning institution in the western slums of Kabul, built by one of the country’s most vulnerable minorities, the Hazara. Marefat educates both girls and boys; it teaches students to embrace the arts, criticize their leaders, interrogate their religion, and be active citizens in a rapidly changing country. But they are dependent on foreign forces for security. When the United States begins to withdraw from Afghanistan, they are left behind, unprotected.<br/><br/>Acclaimed journalist Jeffrey E. Stern explores the stakes of war through the eyes of those touched by Marefat: the school’s daring founder and leader, Aziz Royesh; a mother of five who finds freedom in literacy; a clever mechanic; a self-taught astronomer; the school’s security director; and several intrepid students who carry Marefat’s mission to the streets.<br/><br/>We see how Marefat has embraced the United States and blossomed under its presence---and how much it stands to lose as that protection disappears. <br/><br/><i>The Last Thousand</i> tells the story of what we leave behind when our foreign wars end. It shows us up close the promise, as well as the peril, of our military adventures abroad. Stern presents a nuanced and fascinating portrait of the complex history of Afghanistan, its American occupation, and the ways in which once community rallies together in compelling, heartbreaking, and inspiring detail.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeffrey E. Stern
      </h2>
      
      <p class="authorDescription body article"><P>JEFFREY E. STERN has been named both a Pulitzer Center Fellow for Crisis Reporting, and a Graduate Fellow at the Stanford Center for International Conflict and Negotiation. Stern's reporting has appeared in <I>Vanity Fair, Esquire, Foreign Policy, The Atlantic, Newsweek, Slate, Time,</I> and <I>The New Republic</I>. He has also been featured on PBS News Hour, NPR Morning Edition, and Morning Joe among others.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f2fc413c